export default __webpack_public_path__ + "static/media/banner_desk_rosa_1.6097da03.jpg";